import { render, staticRenderFns } from "./auto_reload.vue?vue&type=template&id=50b5e2a0&"
import script from "./auto_reload.vue?vue&type=script&lang=js&"
export * from "./auto_reload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports